import * as moment from 'moment'

export const isMMDDYYYY = (newDate: string): boolean => {
    const validDate = /^((0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/[0-9]{4})*$/
    const date = moment(newDate, 'MM/DD/YYYY')

    return validDate.test(newDate) && date.isValid()
}
